import { cipher, decipher } from "@/utils/pureFunctions";
import { SECRET_KEY } from "@/utils/constants";
import { IS_DEV, COOKIE_HOST } from "../config";
import Cookies from "universal-cookie";

const cookies = new Cookies(null);

const TOKEN_KEY = "act";
const BEARER_KEY = "act-bearer";
const REFRESH_TOKEN_KEY = "Safe";
// const EXPIRE = "Expire";

const TokenService = {
  getToken() {
    return cookies.get(TOKEN_KEY);
  },

  getBearerToken() {
    return cookies.get(BEARER_KEY);
  },
  setToken(token, expire, refreshToken) {
    const domain = IS_DEV ? "localhost" : COOKIE_HOST;
    cookies.set(TOKEN_KEY, token, {
      domain,
      path: "/",
    });

    // if (expire) {
    //   expire = new Date().getTime() + expire * 1000;
    //   localStorage.setItem(EXPIRE, expire);
    // }
    if (refreshToken) {
      this.setRefreshToken(refreshToken);
    }
  },
  removeToken() {
    const domain = IS_DEV ? "localhost" : COOKIE_HOST;
    cookies.remove(TOKEN_KEY, { domain, path: "/" });
  },
  removeRefreshToken() {
    localStorage.removeItem("damn");
  },
  setRefreshToken(token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, cipher(SECRET_KEY)(token));
  },
  getRefreshToken() {
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    return refreshToken ? decipher(SECRET_KEY)(refreshToken) : null;
  },
};

export default TokenService;
